import PropTypes from 'prop-types';

export const normalizedDefaultProps = {
  ids: [],
  entities: {}
};

export const getNormalizedPropTypes = entityPropTypes => PropTypes.shape({
  ids: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  entities: PropTypes.shape({
    [PropTypes.oneOfType([PropTypes.string, PropTypes.number])]: PropTypes.shape(entityPropTypes)
  })
});
